import { render, staticRenderFns } from "./im-custom-prescription.vue?vue&type=template&id=87bc4926&scoped=true"
import script from "./im-custom-prescription.vue?vue&type=script&lang=js"
export * from "./im-custom-prescription.vue?vue&type=script&lang=js"
import style0 from "./im-custom-prescription.vue?vue&type=style&index=0&id=87bc4926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bc4926",
  null
  
)

export default component.exports